import { PopupProgressComponent } from './popup-progress.component';

export default angular
  .module('sfMobile.components.popup-progress', [
    'sfMobile.components.progress-bar-auto',
  ])
  .component('sfPopupProgress', PopupProgressComponent).name;
